// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { UPDATE_PATH_VALIDATIONS_DRAWER } from './types'

export const updatePathValidationsDrawer = data => ({
  type: UPDATE_PATH_VALIDATIONS_DRAWER,
  data,
})
